import { UseCaseAnchor, UseCaseVersion } from 'src/models/anchor-and-version/use-case.model';
import { Component } from '@angular/core';
import { CrudBaseModalComponent } from '../crud-base-modal/crud-base-modal.component';
import { CrudModalAbstractComponent } from '../crud-base-modal/crud-modal-abstract.component';
import { ModalProps } from '../crud-base-modal/modal-field.interface';

@Component({
    selector: 'app-crud-use-case-modal',
    template: `<app-crud-base-modal #baseModal [modalProps]="modalProps"></app-crud-base-modal>`,
    imports: [CrudBaseModalComponent],
})
export class CrudUseCaseModalComponent extends CrudModalAbstractComponent<
    UseCaseAnchor,
    UseCaseVersion
> {
    public modalProps: ModalProps = {
        title: 'Use Case',
        anchorFields: [
            {
                field: 'userFunctionAnchorKey',
                label: 'User Function',
                type: 'lazy-dropdown',
                required: true,
                order: 2,
            },
            {
                field: 'useCaseId',
                label: 'Use Case Id',
                type: 'number',
                required: true,
                order: 3,
                uniqueCheck: true,
            },
        ],
        versionFields: [
            {
                field: 'changeRequestKey',
                label: 'Change Request',
                type: 'lazy-dropdown',
                required: true,
                order: 1,
            },
            { field: 'name', label: 'Name', type: 'text', required: true, order: 4 },
            { field: 'englishDefinition', label: 'Definition', type: 'textarea', order: 5 },
            { field: 'swedishName', label: 'Swedish Name', type: 'text', order: 6 },
            { field: 'swedishDefinition', label: 'Swedish Definition', type: 'textarea', order: 7 },
            { field: 'oasFpc', label: 'OAS FPC', type: 'text', order: 8 },
            { field: 'comment', label: 'Comment', type: 'textarea', order: 9 },
            { field: 'isActive', label: 'Is Active', type: 'switch', order: 10 },
        ],
    };
}
